// extracted by mini-css-extract-plugin
module.exports = {"viewerRoot":"HtmlEditor_viewerRoot__1Ebd1","editOverlay":"HtmlEditor_editOverlay__3rLuc","editLabel":"HtmlEditor_editLabel__2KYkR"};